<template>
  <v-bottom-sheet :hide-overlay="true" :persistent="true" v-model="show" inset>
    <v-sheet style="padding-bottom: 52px">
      <v-btn
        class="mt-1 float-right mr-1"
        @click="
          () => {
            this['Customer/fetchCustomers']({ page: this.page });
            $router.push('/customer');
          }
        "
        color="error"
        dark
        icon
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-list>
        <v-list-item two-line>
          <v-list-item-content>
            <v-list-item-title>Customer Name</v-list-item-title>
            <v-list-item-subtitle>{{ customer.name }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-list-item two-line>
          <v-list-item-content>
            <v-list-item-title>Address</v-list-item-title>
            <v-list-item-subtitle>{{ customer.address }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-list-item two-line>
          <v-list-item-content>
            <v-list-item-title>Contact Numbers</v-list-item-title>
            <v-list-item-subtitle>{{ customer.contact_numbers }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-list-item two-line>
          <v-list-item-content>
            <v-list-item-title>Date Added</v-list-item-title>
            <v-list-item-subtitle>{{ customer.created_at }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <span class="float-right mr-4" style="background-color: #fff">
        <v-btn @click="deleteCustomer" outlined color="red" class="mb-4">
          Delete
        </v-btn>
        <v-btn @click="goToEdit" color="indigo" outlined class="mb-4">
          Edit
        </v-btn>
      </span>
    </v-sheet>
    <confirm ref="confirm"></confirm>
  </v-bottom-sheet>
</template>

<script>
import { mapState } from 'vuex';
import { mapActions } from 'vuex';
import confirm from '../../components/Confirm.vue';

export default {
  data: function() {
    return {};
  },
  components: {
    confirm
  },
  props: {
    show: false,
    page: 0
  },
  beforeMount() {
    if (this.show) {
      this['Customer/getCustomer']({ id: this.$route.params.id }).finally(() => {
        if (this.customer.name == '') {
          this.$router.push('/customer');
        }
      });
    }
  },
  computed: {
    ...mapState({
      customer(state) {
        if (typeof state.Customer.customer.data == 'undefined') {
          return {
            name: '',
            address: '',
            contact_numbers: ''
          };
        }
        return state.Customer.customer.data;
      }
    })
  },
  methods: {
    ...mapActions(['Customer/fetchCustomers', 'Customer/getCustomer']),
    deleteCustomer() {
      this.$refs.confirm
        .open(
          'Delete Customer',
          'Are you sure you want to delete customer ' + this.customer.name + '?',
          { color: '#f44336' }
        )
        .then(confirm => {
          axios
            .delete(`api/v1/customer/${this.$route.params.id}`)
            .then(response => {
              this.$store.commit('SET_SNACK_BAR', {
                message: 'Customer deleted...',
                color: 'success'
              });
              this['Customer/fetchCustomers']({ page: this.page });
              this.$router.push('/customer');
            })
            .catch(error => {
              if (error.response.status == 403) {
                this.$store.commit(
                  'SET_SNACK_BAR',
                  {
                    message: error.response.data['message'],
                    color: 'error'
                  },
                  { root: true }
                );
              } else {
                this.$store.commit(
                  'SET_SNACK_BAR',
                  {
                    message: error.response.data.errors['id'][0],
                    color: 'error'
                  },
                  { root: true }
                );
              }
            })
            .finally(() => {});
        });
    },
    goToEdit() {
      this.$router.push(`/customer/${this.$route.params.id}/edit`);
    }
  }
};
</script>
